import { PlusOutlined } from "@ant-design/icons";
import { Button, ButtonProps } from "antd";

const CbAddButton = ({
  name = "",
  icon = <PlusOutlined />,
  className = "",
  style: externalStyles = {},
  ...props
}: ButtonProps) => {
  return (
    <Button
      {...props}
      style={{ ...externalStyles }}
      className={`${className}`}
      type="primary"
      icon={icon}
    >
      {name}
    </Button>
  );
};      
export default CbAddButton;
